import { useState } from 'react'
import { ValueMessage } from '../../../ValueNarrativesView/queries/useGetValueNarrativesQuery'

const useValueMessageModal = () => {
    const [valueMessages, setValueMessages] = useState<ValueMessage[] | null>(null)

    const isOpen = valueMessages !== null

    const handleClose = () => {
        setValueMessages(null)
    }

    const handleOpen = (valueMessages: ValueMessage[]) => {
        setValueMessages(valueMessages)
    }

    return {
        isOpen,
        handleOpen,
        handleClose,
        valueMessages,
    }
}

export default useValueMessageModal
